export function formatDate(value, showTime = true) {
  if (!value) return ''
  const options = { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }
  if (showTime) {
    options.hour = '2-digit'
    options.minute = '2-digit'
    options.hour12 = false
  }
  const formatted = new Date(value).toLocaleString('en-US', options)
  return showTime ? formatted + ' UTC' : formatted
}

export function convertToCamelCase(obj) {
  if (Array.isArray(obj)) return obj.map(convertToCamelCase)
  if (!obj || typeof obj !== 'object') return obj
  return Object.fromEntries(
    Object.entries(obj).map(([k, v]) => [
      k.replace(/_([a-z])/g, (_, c) => c.toUpperCase()),
      convertToCamelCase(v)
    ])
  )
}
